module.exports = __webpack_public_path__ + "static/media/ic_right_arrow_24x24.7e07c671.svg";